import { t } from "@lingui/macro";
import { I18n } from "@lingui/core";

import { FieldName } from "..";

export enum AccountType {
  Checking = "checking",
  Savings = "savings",
}

export const accountTypes = (i18n: I18n): Record<AccountType, string> => ({
  [AccountType.Checking]: i18n._(
    t({
      id: "bank-account.account-type.checking",
      message: "Checking (Most common)",
    })
  ),
  [AccountType.Savings]: i18n._(
    t({
      id: "bank-account.account-type.savings",
      message: "Savings",
    })
  ),
});

export default (i18n: I18n) => ({
  local: [
    {
      name: FieldName.bankCode,
      label: "Routing number",
      placeholder: `${i18n._(
        t({
          id: "placeholder.example",
          message: "e.g.",
        })
      )} 026073150`,
      instructions: i18n._(
        t({
          id: "fields-config.bank-code.instructions",
          message: "Bank code",
        })
      ),
    },
    {
      name: FieldName.accountNumber,
      label: "Account number",
      placeholder: `${i18n._(
        t({
          id: "placeholder.example",
          message: "e.g.",
        })
      )} 2715500356`,
      instructions: i18n._(
        t({
          id: "fields-config.account-number.instructions",
          message: "Account number",
        })
      ),
    },
    {
      name: FieldName.accountType,
      label: "Account type",
      placeholder: "",
      instructions: "",
      options: accountTypes(i18n),
    },
  ],
  primaryBankDetailsFields: [
    FieldName.bankCode,
    FieldName.accountNumber,
    FieldName.accountType,
  ],
  secondaryBankDetailsField: [],
});
